import { Auth, statuses } from "@icg360/ipc-auth-js";
import * as Sentry from "@sentry/react";

import AP from "../legacy/global";

import { getApiUrl } from "./get-api-url";
import storage from "./storage";
import * as cookies from "./cookies";

interface IxAuthResponse {
  status: string;
  message: string;
}

export const logout = (message?: string) => {
  if (message) {
    storage.setItem("login-message", message);
  }
  const cookieOptions = createCookieOptions();
  cookies.write("aptoken", "", cookieOptions);
  cookies.write("apb64", "", cookieOptions);
  cookies.write("auth-session-uri", "", cookieOptions);
  cookies.write("Authorization", "", cookieOptions);
  cookies.write("apagenttoken", "", cookieOptions);
  if (AP && AP.config) {
    const authClient = new Auth({
      servicesUrl: getApiUrl("ixauth")
    });
    authClient.logout().then((response: IxAuthResponse) => {
      if (response.status === statuses.genericFailure) {
        // eslint-disable-next-line
        console.warn(response.message);
        return;
      }
      Sentry.setUser(null);
      redirect();
    });
  } else {
    redirect();
  }
};

function redirect() {
  if (cookies.read("agencylocationid") != null) {
    cookies.write("agencylocationid", "", createCookieOptions());
    document.location.href = "support/index.html";
  } else {
    // this handles urls that have query strings in them and hashes
    let newLocationUrl = `/login.html`;
    if (window.location.search) {
      // if the url contains search (i.e. ?_somekey=somevalue)
      // append to /login.html the entire search
      newLocationUrl += `${window.location.search}`;
      // then add the redirect from where we logged out at
      if (window.location.hash) {
        const redirectUrl = window.location.hash.replace("#", "/");
        newLocationUrl += `&redirect=${redirectUrl.replace("//", "/")}`;
      } else {
        newLocationUrl += `&redirect=${window.location.pathname}`;
      }
    } else if (window.location.hash) {
      // if there is no search, but there is a hash, use the hash as a redirect
      const redirectUrl = window.location.hash.replace("#", "/");
      newLocationUrl += `?redirect=${redirectUrl.replace("//", "/")}`;
    } else {
      newLocationUrl += `?redirect=${window.location.pathname}`;
    }
    // finally redirect
    document.location.href = newLocationUrl;
  }
}

function createCookieOptions() {
  return {
    expires: new Date()
  };
}
